import React from 'react';
import {withStore} from "../../hocs";
import {observer} from "mobx-react";
import {BreadCrumbs} from "../../components/tpl/BreadCrumbs";
import {RedirectUrl} from "../../components/RedirectUrl";
import {Link} from "react-router-dom";
import {adminPanelUrl} from "../../constants/adminPanelPath";


// @ts-ignore
@withStore
@observer
export class AdminPage extends React.Component {

    componentDidMount() {
        // @ts-ignore
        const {store} = this.props;
        store.basePageStore.setBreadCrumbs([{name: 'Администрирование', url: adminPanelUrl()}]).setTitleInBreadCrumbs();
        store?.componentTopSearchStore.clearSearch();
    }

    render() {
        return (
            <>
                <RedirectUrl/>
                <div className="container">
                    <div className="breadcrumbs">
                        <div className="breadcrumbs-wrapper">
                            <BreadCrumbs/>
                        </div>
                    </div>
                    <div className="catalog-title">
                        <h1 className="catalog-title__text">Администрирование</h1>
                    </div>
                    <div className="about about__personal">
                        <br/>
                        <Link className={"new-price"} to={adminPanelUrl('auth')}>
                            Авторизация под пользователем
                        </Link>
                        <br/>
                        <br/>
                        <Link  className={"new-price"}  to={adminPanelUrl('email-replay')}>
                            Повторная отправка пользователям подтверждения электронной почты
                        </Link>
                        <br/>
                        <br/>
                        <Link  className={"new-price"}  to={adminPanelUrl('quiz-report')}>
                            Посмотреть отчет по опросу
                        </Link>
                        <br/>
                        <br/>
                        <Link  className={"new-price"}  to={adminPanelUrl('user-log')}>
                            Журнал событий пользователей
                        </Link>
                         <br/>
                        <br/>
                        <Link  className={"new-price"}  to={adminPanelUrl('products-without-image')}>
                            Таблица товаров без картинок
                        </Link>
                    </div>
                </div>
            </>
        )
    }
}